import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserPlus, Check, Search } from "lucide-react";
import { getStaffChatElite } from "../../../services/chatElite.service";
import { iniciales } from "./ListaTicketsStaff";

// La lista de staff cambia poco: se pide una vez por sesion de pagina
let cacheStaff = null;
const cargarStaff = () => {
  if (!cacheStaff) {
    cacheStaff = getStaffChatElite().then((r) => r.staff || []).catch((e) => {
      cacheStaff = null;
      throw e;
    });
  }
  return cacheStaff;
};

/**
 * Desplegable para asignar el ticket a una o varias personas del equipo.
 */
const SelectorAsignar = ({ asignados = [], onAsignar, deshabilitado }) => {
  const { t } = useTranslation("common");
  const [abierto, setAbierto] = useState(false);
  const [staff, setStaff] = useState([]);
  const [filtro, setFiltro] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    if (abierto && !staff.length) cargarStaff().then(setStaff).catch(() => {});
  }, [abierto, staff.length]);

  useEffect(() => {
    if (!abierto) return undefined;
    const fuera = (e) => ref.current && !ref.current.contains(e.target) && setAbierto(false);
    const esc = (e) => e.key === "Escape" && setAbierto(false);
    document.addEventListener("mousedown", fuera);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", fuera);
      document.removeEventListener("keydown", esc);
    };
  }, [abierto]);

  const idsAsignados = new Set(asignados.map((a) => a.user_id));
  const filtrados = useMemo(() => {
    const f = filtro.trim().toLowerCase();
    return staff.filter((s) => !f || (s.nombre || "").toLowerCase().includes(f));
  }, [staff, filtro]);

  return (
    <div className="cep-selector" ref={ref}>
      <button type="button" className="cep-boton cep-boton--secundario" onClick={() => setAbierto((v) => !v)} disabled={deshabilitado} aria-haspopup="listbox" aria-expanded={abierto}>
        <UserPlus size={14} /> {t("chatElite.panel.asignarA")}
      </button>
      {abierto && (
        <div className="cep-selector__lista" role="listbox">
          <label className="cep-buscar cep-buscar--compacto">
            <Search size={13} />
            <input autoFocus value={filtro} onChange={(e) => setFiltro(e.target.value)} placeholder={t("chatElite.panel.buscarPersona")} />
          </label>
          <div className="cep-selector__opciones">
            {!staff.length && <span className="cep-selector__vacio">{t("chatElite.comun.cargando")}</span>}
            {filtrados.map((s) => {
              const ya = idsAsignados.has(s.user_id);
              return (
                <button
                  key={s.user_id}
                  type="button"
                  role="option"
                  aria-selected={ya}
                  disabled={ya}
                  onClick={() => {
                    setAbierto(false);
                    onAsignar(s.user_id);
                  }}
                >
                  <span className="cep-avatar">{iniciales(s.nombre)}</span>
                  <span className="cep-selector__nombre">{s.nombre}</span>
                  <span className="cep-selector__rol">{s.rol}</span>
                  {ya && <Check size={14} />}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectorAsignar;
